// https://vuex.vuejs.org/en/getters.html

export default {
  products(state) {
    return state.products;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  },
  filterValues(state) {
    return state.filterValues;
  }
};
